import './styles.scss'
import React, { useState } from 'react'
import { Modal } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { InputControls } from 'components/common'
import { Button } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const ModalWrapper = (props) => {
  const {
    id,
    isOpen,
    toggle,
    backdrop,
    header,
    legend,
    body,
    footer,
    isEnabledSwitch,
    valueSwitch,
    onChangeSwitch,
    keyboard,
    eventBtnTxt,
    eventBtn,
    cancelBtnTxt,
    cancelBtn,
    contentClassName,
    isSubmitting,
    error,
    showClose = true,
    disabled,
    headerBtn,
    headerBtnText,
    iconName
  } = props
  const [switchValue, setSwitchValue] = useState(valueSwitch || false)

  return (
    <Modal centered id={id} isOpen={isOpen} toggle={toggle} className={''} contentClassName={`modal-content-general ${contentClassName ? contentClassName : ''}`} backdrop={backdrop} keyboard={keyboard}>
      {header &&
        <div className='modal-wrapper-header'>
          <div>
            <div className='modal-wrapper-header__icon-header'>
              {iconName &&
                <img
                  src={`${getStaticImage(`/icons/orange-brand/${iconName}.svg`)}`}
                  alt={iconName}
                  onError={event => {
                    event.target.className = 'not-channel-icon'
                    event.onerror = null
                  }}
                />
              }
              <h1>{header}</h1>
            </div>
            {legend ? <legend>{legend}</legend> : null}
          </div>
          <div className={isEnabledSwitch || headerBtn ? 'modal-wrapper-content-input' : ''}>
            {isEnabledSwitch && (
              <InputControls
                label={I18n.t('dashboard_buttons-format')}
                labelLeft={I18n.t('dashboard_text-format')}
                value={switchValue}
                onChange={value => {
                  setSwitchValue(value)
                  onChangeSwitch(value)
                }}
              />
            )}
            {headerBtn &&
              <Button
                className={'modal-wrapper-content-input__button'}
                secondary
                value={headerBtnText}
                onClick={headerBtn}
                isSubmitting={isSubmitting}
              />
            }
            {showClose && <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='close' onClick={toggle} />}
          </div>
        </div>
      }
      {body && (
        <div className ='modal-wrapper-body'>
          {body}
        </div>
      )}
      {(footer || eventBtn || cancelBtn) && (
        <div className='modal-wrapper-footer'>
          {error && <p className='modal-wrapper-error'>{error}</p>}
          {footer ? footer : (
            (eventBtn || cancelBtn) && (
              <div className='modal-wrapper-buttons'>
                {eventBtn ? (
                  <Button
                    secondary
                    value={eventBtnTxt}
                    onClick={eventBtn}
                    isSubmitting={isSubmitting}
                    disabled={disabled}
                  />
                ) : null}
                {cancelBtn ? <Button value={cancelBtnTxt} onClick={cancelBtn}/> : null}
              </div>
            )
          )}
        </div>
      )}
    </Modal>
  )
}

export default ModalWrapper
